import { formatDateShort, titleizeAlt } from '../../../utils/helpers';

export const DISPLAY_NAME_FIELD_SUMMARY_ITEM = {
  label: 'Name',
  accessor: 'displayName',
};

export const HYDROCARBON_TYPE_FIELD_SUMMARY_ITEM = {
  label: () => 'Hydrocarbon Type',
  accessor: f => titleizeAlt(f?.hydrocarbonType, '/'),
};

export const PRODUCTION_START_DATE_FIELD_SUMMARY_ITEM = {
  label: () => 'Production Start Date',
  accessor: f => formatDateShort(f?.firstProductionDate),
};

export const PRODUCTION_CESSATION_DATE_FIELD_SUMMARY_ITEM = {
  label: () => 'Production Cessation Date',
  accessor: f => formatDateShort(f?.productionCessationDate),
};

export const WATER_DEPTH_M_MAX_FIELD_SUMMARY_ITEM = {
  label: () => 'Max Water Depth (m)',
  accessor: w => (w?.waterDepthMMax > 0 ? w?.formattedWaterDepthMax : null),
};

export const WATER_DEPTH_M_MIN_FIELD_SUMMARY_ITEM = {
  label: () => 'Min Water Depth (m)',
  accessor: w => (w?.waterDepthMMin > 0 ? w?.formattedWaterDepthMin : null),
};

export const PROJECT_SANCTION_DATE_FIELD_SUMMARY_ITEM = {
  label: () => 'Project Sanction Date',
  accessor: f => formatDateShort(f?.projectSanctionDate),
};

export const DISCOVERY_WELL_SUMMARY_ITEM = {
  label: 'Discovery Well',
  accessor: f => f?.discoveryWell?.displayName,
};

export const DISCOVERED_BY_SUMMARY_ITEM = {
  label: 'Discovered By',
  accessor: f => f?.discoveryWell?.drilledBy,
};

export const DISCOVERY_HYDROCARBON_TYPE_SUMMARY_ITEM = {
  label: 'Discovery Hydrocarbon Type',
  accessor: f => f?.discoveryWell?.primaryHydrocarbon || f?.discoveryWell?.wellResult,
};

export const FORMATION_DISCOVERED_SUMMARY_ITEM = {
  label: 'Formation Discovered',
  accessor: f => f?.discoveryWell?.wellFormation,
};

export const DISCOVERY_WELL_TOTAL_DEPTH_M_SUMMARY_ITEM = {
  label: 'Discovery Well Total Depth (m)',
  accessor: f =>
    f?.discoveryWell?.formattedDepthMeasure || f?.discoveryWell?.formattedDepthVertical,
};

export const DISCOVERY_WELL_WATER_DEPTH_SUMMARY_ITEM = {
  label: 'Discovery Well Water Depth (m)',
  accessor: f => (f?.discoveryWell?.waterBlade > 0 ? f?.discoveryWell?.formattedWaterBlade : null),
};

export const DISCOVERY_DATE_SUMMARY_ITEM = {
  label: 'Discovery Date',
  accessor: f => {
    const drillingEndDate = f?.discoveryWell?.drillingEndDate;

    if (drillingEndDate) {
      return formatDateShort(drillingEndDate);
    }

    const drillingYear = f?.discoveryWell?.drillingYear;

    if (drillingYear) {
      return drillingYear;
    }

    const drillingStartDate = f?.discoveryWell?.drillingStartDate;

    if (drillingStartDate) {
      return formatDateShort(drillingStartDate);
    }

    const discoveryDate = f?.discoveryDate;

    if (discoveryDate) {
      return formatDateShort(discoveryDate);
    }

    return null;
  },
};
